module.exports = __webpack_public_path__ + "h5/img/touxiang.6e71e685.jpg";